import { Form, Input } from 'decorator-form';

import InputType from 'common/form/InputType';
import { TypographyStylesConfig, typographyStylesInput } from '../common/TypographyStylesConfig';

@Form({title: "Typography View Config"})
export default class TypographyViewConfig {

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color: string;

	@Input({type: typographyStylesInput, title: "Text Style"})
	public typography: TypographyStylesConfig;

	@Input({type: InputType.NUMBER, title: "Line clamp (vertical)"})
	public lineClamp: number;
}



// WEBPACK FOOTER //
// ./src/common/views/typographyView/TypographyViewConfig.ts